<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table 
                            class="noFullHeight" 
                            :settings="tableConfig" 
                            :table-items="tableItems" 
                            @load-items="getTableData" 
                            @new-item="gotoDetail" 
                            @row-click="gotoDetail" 
                            @delete-items="deleteItems" 
                            ref="gofixTable">
                            <template slot="gofix_table:parent_device_tag" slot-scope="row">
                                {{row.item.parent_device_tag ? row.item.parent_device_tag : "--"}}
                            </template>
                            <template slot="gofix_table:bypass_meter" slot-scope="row">
                                {{row.item.related_devices[0] && row.item.parent_id && row.item.parent_id != 1 ? row.item.related_devices[0].device_tag : ""}}
                            </template>
                            <template slot="gofix_table:lastLog.consumption" slot-scope="row">
                                {{ $accounting.formatNumber(row.item.lastLog && row.item.lastLog.consumption, 3, " ") }}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
var accounting = require('accounting');

export default {
    name: 'electricity-meter-listing',
    data() {
        return {
            tableConfig: {
                name: 'utilities-management-electricity-meters',
                controls: {
                    create: this.$checkRole(this.$accessModule.electricity_meter_listing, 'create'),
                    delete: this.$checkRole(this.$accessModule.electricity_meter_listing, 'delete'),
                },
                filter: JSON.parse(JSON.stringify(filters['electricity_meter_listing'])),
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
            },
            tableItems: [],
        }
    },
    computed: {
        ...mapGetters({
            Items: 'ElectricityMeteringDevicesController/Items'
        })
    },
    created() {},
    methods: {
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            await this.$store.dispatch("ElectricityMeteringDevicesController/getList", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    this.$alertNotification("Can not load the items", "danger");
                    reject();
                })
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            await this.$store.dispatch('ElectricityMeteringDevicesController/deleteItems', ids)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(err => {
                    reject();
                })
        },
        gotoDetail(item = null) {
            this.$router.push(`/v2/electricity-meter/${item ? item.id : 'add'}`);
        }
    }
}
</script>